;{
    window.packageInfo = window.packageInfo || {};
    window.packageInfo['inforcontrolscombined'] = {
      info: 'Infor Public Sector v11.2.2',
      date: '1742861838051',
      revisionNumber: '2'
    };
  };